import React, { Fragment, useState } from "react";
import { Box, Card, Container, Grid, styled, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import TextFieldTheme from "../../shared/general/TextFieldTheme";
import ButtonBlue from "../../shared/general/ButtonBlue";
import { useDispatch } from "react-redux";
import { forgetPassword } from "../../../../actions/account";
import { Link } from "react-router-dom";

const StyledRoot = styled(Box)({
  backgroundColor: "#FFFFFF !important",
})

const RenderForm = (props) => {

  const dispatch = useDispatch();

  const { setIsSuccess } = props;
  const [isFetching, setIsFetching] = useState(false);

  const { control, handleSubmit, setError } = useForm({
    defaultValues: {
      email: "",
    }
  });

  const onSubmit = async (submittedData) => {

    setIsFetching(true);
    
    const res = await dispatch(forgetPassword(submittedData));

    if(res){
      setIsFetching(false);
      if(res.status === 200){
        if(res.data.errorCode === "EMAIL_NOT_FOUND"){
          setError("email", { type: "custom", message: "อีเมลนี้ไม่มีอยู่ในระบบ"})
        } else {
          setIsSuccess(true)
        }
      } else {
        setError("email", { type: "custom", message: "เกิดข้อผิดพลาดของระบบ กรุณาติดต่อแอดมิน"})
      }
    }
  }

  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5">ลืมรหัสผ่าน</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography fontSize={14} color="text.third">โปรดกรอกอีเมลของคุณในช่องด้านล่าง ระบบจะส่งลิงก์ตั้งค่ารหัสผ่านใหม่ไปที่อีเมลของคุณ</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography fontSize={14} paddingBottom="8px">อีเมล</Typography>
            <Controller
              control={control}
              name="email"
              rules={{
                required: {value: true, message: "กรุณากรอกอีเมล"},
                pattern: {
                 value: /^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-z.]{1,}[A-z]$/,
                 message: "กรุณากรอกอีเมลให้ถูกต้อง เช่น 'unihr@example.com'"
                }
              }}
              render={({field, formState}) => (
                <TextFieldTheme
                  {...field}
                  autoComplete="email"
                  helperText={formState.errors && formState.errors[field.name] && formState.errors[field.name].message}
                  error={formState.errors && formState.errors[field.name] ? true: false}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <ButtonBlue type="submit" variant="contained" fullWidth sx={{paddingTop: "12px", paddingBottom: "12px"}} disabled={isFetching}>ดำเนินการต่อ</ButtonBlue>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <ButtonBlue component={Link} to="/login">เข้าสู่ระบบ</ButtonBlue>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  )
}

const RenderMessage = () => {
  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h5">คำขอตั้งค่ารหัสผ่านใหม่</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontSize={14} color="text.third">ระบบได้ทำการส่งลิงก์ตั้งค่ารหัสผ่านใหม่ไปที่อีเมลของคุณเรียบร้อยแล้ว โปรดตรวจสอบอีเมลของคุณ โดยลิงก์จะหมดอายุภายใน 15 นาที</Typography>
        </Grid>
      </Grid>
    </Fragment>
  )
}

const ForgetPasswordPage = () => {

  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <StyledRoot className="page">
      <Container maxWidth="sm">
        <Card sx={{padding: "48px", boxShadow: 2}}>
          {!isSuccess && (
            <RenderForm
              setIsSuccess={setIsSuccess}
            />
          )}
          {isSuccess && (
            <RenderMessage />
          )}
        </Card>
      </Container>
    </StyledRoot>
  )
}

export default ForgetPasswordPage